var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-8 font-bold text-3xl"},[_vm._v("Wykres - Wartość faktur")]),_vm._v(" "),_c('line-chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions,"height":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }